import { Link } from 'react-router-dom'
import styled from 'styled-components'

// styles for assessment listing page : heading, description, and assessment item tiles

export const ALPMainSectionContainer = styled.div`
  padding: 90px 0px 90px;
  font-family: Outfit;
  @media (min-width: 768px) {
    padding: 90px 0px 90px;
  }
`

export const ALPMainSectionInternalContainer = styled.div`
  width: 100%;
  max-width: 962px;
  margin: auto;
`

export const ALPMainSectionHeading = styled.h1`
  max-width: 300px;
  font-size: 40px;
  font-weight: 600;
  line-height: 52px;
  margin: 0 auto;
  color: #27325a;
  text-align: center;
  margin-bottom: 15px;
  @media (min-width: 768px) {
    font-size: 46px;
    max-width: 768px;
  }
`

export const ALPMainSectionDescription = styled.div`
  color: #314d5c;
  margin-left: auto;
  margin-right: auto;
  max-width: 320px;
  text-align: center;
  font-size: 16px;
  line-height: 25px;
  @media (min-width: 768px) {
    max-width: 720px;
  }
`

export const ALPMainSectionCaret = styled.img`
  width: 22px;
  height: 10px;
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
`

export const ALPMainSectionItemsContainer = styled.div`
  max-width: 428px;
  padding-top: 43px;
  padding-left: 12px;
  padding-right: 12px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  @media (min-width: 480px) {
    max-width: 460px;
    padding-left: 0;
    padding-right: 0;
  }
  @media (min-width: 768px) {
    max-width: 636px;
  }
  @media (min-width: 992px) {
    max-width: 960px;
  }
`

export const ALPMainSectionItemBackground = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  object-fit: cover;
  object-position: center;
  transition: transform 0.4s ease-in-out;
  filter: brightness(0.5);
  background: #27325a;
`

export const ALPMainSectionItemDetails = styled.div`
  z-index: 2;
  position: absolute;
  top: 30%;
  transform: translate3d(0px, 18px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg)
    skew(0deg, 0deg);
  transform-style: preserve-3d;
  transition: transform 0.4s ease-in-out;
`

export const ALPMainSectionItemHeading = styled.h2`
  max-width: 250px;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  margin-bottom: 0;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
  font-weight: 600;
  @media (min-width: 480px) {
    max-width: 280px;
  }
  @media (min-width: 768px) {
    font-size: 28px;
    line-height: 32px;
  }
`

export const ALPMainSectionItemStartText = styled.div`
  opacity: 0;
  color: #fff;
  margin-top: 15px;
  margin-left: auto;
  margin-right: auto;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  transition: transform 0.4s ease-in-out;
`

export const ALPMainSectionItemContainer = styled(Link)`
  position: relative;
  height: 196px;
  width: 100%;
  border-radius: 7px;
  transition: all 0.4s ease-in-out;
  cursor: pointer;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @media (min-width: 480px) {
    max-width: 45%;
  }
  @media (min-width: 768px) {
    height: 225px;
    max-width: 302px;
  }
  &:hover {
    ${ALPMainSectionItemBackground} {
      transform: scale(1.05);
    }
    ${ALPMainSectionItemStartText} {
      opacity: 1;
    }
    ${ALPMainSectionItemDetails} {
      transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg)
        rotateZ(0deg) skew(0deg, 0deg);
    }
  }
  text-decoration: none;
  &:focus,
  &:active {
    outline: none;
  }
`

export const ALPMainSectionItemContainerOnClickOverride = styled('div')`
  position: relative;
  height: 196px;
  width: 100%;
  border-radius: 7px;
  transition: all 0.4s ease-in-out;
  cursor: pointer;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @media (min-width: 480px) {
    max-width: 45%;
  }
  @media (min-width: 768px) {
    height: 225px;
    max-width: 302px;
  }
  &:hover {
    ${ALPMainSectionItemBackground} {
      transform: scale(1.05);
    }
    ${ALPMainSectionItemStartText} {
      opacity: 1;
    }
    ${ALPMainSectionItemDetails} {
      transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg)
        rotateZ(0deg) skew(0deg, 0deg);
    }
  }
  text-decoration: none;
  &:focus,
  &:active {
    outline: none;
  }
`

export const ALPDarkButton = styled.button`
  background: #efedeb;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  color: #000;
  padding: 5px 15px;
  border-radius: 100px;
`

export const ALPFilterOptionHeading = styled.div`
  font-size: 22px;
  font-weight: 500;
  margin: 20px 0 10px;
`

export const ALPFilterOptionsContainer = styled.div`
  display: flex;
  justify-content: left;
  align-items: top;
  gap: 5px;
  flex-wrap: wrap;
`

export const ALPFilterOption = styled.div`
  border: ${(props) => (props?.selected ? '1px solid #000' : '1px solid rgb(255,255,255,0.5)')};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px 10px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  background: ${(props) => (props?.selected ? '#ffffff' : '#f7f6f5')};
  width: ${(props) => (props?.wider ? '160px' : '124px')};
`

export const ALPFilterFinalActionButton = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-weight: 500;
  max-width: 340px;
  padding: 15px;
  border-radius: 8px;
  background: #6150a2;
  color: #fff;
  font-size: 20px;
  &:hover {
    background: #514387;
  }
`

// styles for Info And Single Action Component Variant One :

export const IASACVarOneContainer = styled.div`
  width: 100%;
  font-family: Outfit;
  padding-top: 106px;
  padding-bottom: 46px;
  padding-left: 5%;
  padding-right: 5%;
  position: relative;
  display: flex;
  @media (min-width: 768px) {
    align-items: center;
  }
`

export const IASCDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  @media (min-width: 768px) {
    align-items: flex-start;
  }
`

export const IASACVarOneHeading = styled.h1`
  color: #fff;
  font-size: 30px;
  line-height: 40px;
  max-width: 320px;
  text-align: center;
  margin-bottom: 5px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 700;
  position: relative;
  z-index: 2;
  @media (min-width: 768px) {
    font-size: 46px;
    max-width: 430px;
    line-height: 58px;
    text-align: left;
    margin: 0.67em 0;
    margin-top: 0;
  }
`

export const IASACVarOneDescription = styled.div`
  color: #fff;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  font-size: 18px;
  line-height: 28px;
  z-index: 2;
  position: relative;
  @media (min-width: 768px) {
    max-width: 400px;
    text-align: left;
    margin: 0;
  }
`

export const IASACVarOneButton = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
  background: #103e42;
  position: relative;
  transition: all 0.2s ease-in-out;
  width: 250px;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  padding-top: 13px;
  padding-bottom: 13px;
  font-size: 17px;
  line-height: 23px;
  font-weight: 700;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  z-index: 2;
  @media (min-width: 768px) {
    margin-left: 0;
  }
`

export const IASACVarOneBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const IASACVarOneBackgroundImageOne = styled.div`
  height: 70%;
  width: 100%;
  position: absolute;
  top: 0;
  background-image: linear-gradient(to bottom, rgba(85, 113, 131, 1) 60%, rgba(85, 113, 131, 0));
  z-index: 1;
  @media (min-width: 768px) {
    top: unset;
    left: 0;
    width: 70%;
    height: 100%;
    background-image: linear-gradient(to right, rgba(85, 113, 131, 1) 60%, rgba(85, 113, 131, 0));
  }
`

export const IASACVarOneBackgroundImageTwo = styled.img`
  height: 70%;
  width: 100%;
  position: absolute;
  bottom: 0;
  object-fit: cover;
  object-position: center;
  z-index: 0;
  @media (min-width: 768px) {
    bottom: unset;
    right: 0;
    width: 70%;
    height: 100%;
  }
`

// styles for Info Heading and Info Description and Info Image

export const IWHDAIVarOneContainer = styled.div`
  width: 100%;
  padding: 20px;
  position: relative;
  font-size: 18px;
  line-height: 28px;
  color: #333;
  display: flex;
  flex-direction: ${(props) => (props?.pictureOnLeftVariant ? 'column' : 'column-reverse')};
  align-items: center;
  gap: 20px;
  @media (min-width: 768px) {
    padding: 35px;
    flex-direction: row;
    justify-content: center;
    gap: 100px;
  }
`

export const IWHDAIVarOneHeadline = styled.h1`
  width: 100%;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: #263159;
  margin-bottom: 18px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 768px) {
    font-size: 42px;
    line-height: 46px;
  }
  @media (min-width: 992px) {
    text-align: left;
    margin-left: 0;
  }
`
export const IWHDAIVarOneHeadline2 = styled.h2`
  width: 100%;
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: #263159;
  margin-bottom: 18px;
  margin-left: auto;
  margin-right: auto;
  @media (min-width: 768px) {
    font-size: 42px;
    line-height: 46px;
  }
  @media (min-width: 992px) {
    text-align: left;
    margin-left: 0;
  }
`

export const IWHDAIVarOneDescription = styled.div`
  width: 100%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  color: #314d5c;
  font-size: 18px;
  line-height: 28px;
  @media (min-width: 992px) {
    text-align: left;
  }
`

export const IWHDAIVarOneImage = styled.img`
  border-radius: 15px;
  flex-shrink: 0;
  margin: auto 0;
  box-shadow: 0 11px 50px -18px rgba(77, 101, 98, 0.5);
  height: 200px;
  width: 200px;
  object-fit: cover;
  @media (min-width: 768px) {
    height: 250px;
    width: 250px;
  }
`
